/**
 * useRoundConfigsByPerformance — React Query hook fetching all
 * `rodeo_round_configs` rows for a given performance in a single call.
 *
 * The PerformanceSection uses this to annotate each event row with its
 * round count without firing a per-event query. Consumers group by
 * `event_id` client-side.
 */

import { useQuery } from '@tanstack/react-query';
import { RodeoRoundConfigsClient } from '../api/generated_clients/generated-rodeo_round_configs-api-client';
import { rodeoRoundConfigsKeys } from '../api/generated_hooks/generated-rodeo_round_configs-hooks';
import type { RodeoRoundConfigsRow } from '../types/generated_schemas/generated-rodeo_round_configs-schema';

export function useRoundConfigsByPerformance(performanceId: string | undefined) {
  const client = new RodeoRoundConfigsClient();

  return useQuery<RodeoRoundConfigsRow[]>({
    queryKey: performanceId
      ? rodeoRoundConfigsKeys.list({ performance_id: performanceId })
      : rodeoRoundConfigsKeys.lists(),
    queryFn: () =>
      client.getAll({
        filters: { performance_id: performanceId! },
      }),
    enabled: !!performanceId,
  });
}
